import { createTheme } from '@mui/material';
import {
  getMuiButtonDefaultProps,
  getMuiButtonOverrides,
  getMuiIconButtonDefaultProps,
  getMuiIconButtonOverrides,
  getMuiToggleButtonDefaultProps,
  getMuiToggleButtonOverrides,
} from 'theme/Button';
import { COLOR_BLACK } from 'theme/colors';
import { getMuiContainerDefaultProps, getMuiContainerOverrides } from 'theme/Container';
import { breakpointOptions, getMuiGridDefaultProps, getMuiGridOverrides } from 'theme/Grid';
import { getTypographyOptions } from 'theme/Typography';

import { getMuiCheckbox, getMuiCheckboxDefaultProps } from './Checkbox/Checkbox.theme';
import { getMuiAccordion, getMuiAccordionDetails, getMuiAccordionPropsDefaultProps } from './Accordion';
import { getMuiBackdropDefaultProps, getMuiBackdropOverrides } from './Backdrop';
import { getMuiCssBaselineDefaultProps, getMuiCssBaselineOverrides } from './CssBaseLine';
import { getMuiDialogDefaultProps, getMuiDialogOverrides } from './Dialog';
import { getMuiPopoverDefaultProps, getMuiPopoverOverrides } from './Popover';
import { getMuiSelectDefaultProps, getMuiSelectOverrides } from './Select';
import { getMuiTextFieldDefaultProps, getMuiTextFieldOverrides } from './TextField';

const themeBase = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: COLOR_BLACK,
    },
  },
  typography: getTypographyOptions(),
  breakpoints: breakpointOptions,
});

export const theme = createTheme(themeBase, {
  components: {
    MuiGrid: {
      defaultProps: getMuiGridDefaultProps(),
      styleOverrides: getMuiGridOverrides(),
    },
    MuiContainer: {
      defaultProps: getMuiContainerDefaultProps(),
      styleOverrides: getMuiContainerOverrides(),
    },
    MuiBackdrop: {
      defaultProps: getMuiBackdropDefaultProps(),
      styleOverrides: getMuiBackdropOverrides(themeBase),
    },
    MuiButton: {
      defaultProps: getMuiButtonDefaultProps(),
      styleOverrides: getMuiButtonOverrides(themeBase),
    },
    MuiIconButton: {
      defaultProps: getMuiIconButtonDefaultProps(),
      styleOverrides: getMuiIconButtonOverrides(),
    },
    MuiToggleButton: {
      defaultProps: getMuiToggleButtonDefaultProps(),
      styleOverrides: getMuiToggleButtonOverrides(themeBase),
    },
    MuiDialog: {
      defaultProps: getMuiDialogDefaultProps(),
      styleOverrides: getMuiDialogOverrides(),
    },
    MuiCssBaseline: {
      defaultProps: getMuiCssBaselineDefaultProps(),
      styleOverrides: getMuiCssBaselineOverrides(themeBase),
    },
    MuiPopover: {
      defaultProps: getMuiPopoverDefaultProps(),
      styleOverrides: getMuiPopoverOverrides(themeBase),
    },
    MuiSelect: {
      defaultProps: getMuiSelectDefaultProps(),
      styleOverrides: getMuiSelectOverrides(themeBase),
    },
    MuiCheckbox: {
      defaultProps: getMuiCheckboxDefaultProps(),
      styleOverrides: getMuiCheckbox(themeBase),
    },
    MuiTextField: {
      defaultProps: getMuiTextFieldDefaultProps(),
      styleOverrides: getMuiTextFieldOverrides(themeBase),
    },
    MuiAccordion: {
      defaultProps: getMuiAccordionPropsDefaultProps(),
      styleOverrides: getMuiAccordion(themeBase),
    },
    MuiAccordionDetails: {
      styleOverrides: getMuiAccordionDetails(themeBase),
    },
  },
});
